import apiClient from "../../api/notificationApiClient"

/**
 * @async
 * @function getNotificationsRequest
 * @description Retrieves notifications for a given user, with optional filters.
 *
 * @param {string} email - User email used to fetch notifications
 * @param {boolean} read - Indicates whether to fetch read or unread notifications
 * @param {string} [type] - Optional notification type filter
 *
 * @returns {Promise<any>} - Notifications list returned by the API
 */
export const getNotificationsRequest = async(email, read, type) => {
    const params = {
        email,
        read
    }
    if(type) {
        params.type = type
    }

    const getNotificationsResponse = await apiClient.get(import.meta.env.VITE_NOTIFICATION, { params })

    return getNotificationsResponse.data
}

/**
 * @async
 * @function updateNotificationRequest
 * @description Marks a notification as updated/read.
 *
 * @param {string|number} notificationId - Unique identifier of the notification
 *
 * @returns {Promise<any>} - Updated notification response from the API
 */
export const updateNotificationRequest = async(notificationId) => {
    const params = {
        id: notificationId
    }
    const updateNotificationResponse = await apiClient.put(import.meta.env.VITE_NOTIFICATION, null, { params })

    return updateNotificationResponse.data
}

/**
 * @async
 * @function updateAllNotificationsRequest
 * @description Marks all notifications as updated/read.
 *
 * @param {string} email - Unique identifier of the notification
 *
 * @returns {Promise<any>} - Updated notification response from the API
 */
export const updateAllNotificationsRequest = async (email) => {
    return apiClient.put('notification/updateAll', null, {
        params: { email }
    });
};